import { SwipeableDrawer, Grid, ThemeProvider } from '@mui/material';
import composeTheme from '@theme/theme';
import { IconButton } from '@components/iconButton';
import { Times } from '@assets/svgs';
import { useGetScreenSize } from '@utils/useGetScreenSize';

type TBottomDrawerProps = {
  isOpen: boolean;
  toggleDrawer: () => void;
  header: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
};
export const BottomDrawer = ({ isOpen, toggleDrawer, header, children, footer }: TBottomDrawerProps) => {
  const { isMobileScreen } = useGetScreenSize();

  const drawerStyles = {
    '& .MuiPaper-root': { maxHeight: '50%', minHeight: '20%' },
    '& .MuiDrawer-paper': { borderRadius: '20px 20px 0 0' },
  };
  return isMobileScreen ? (
    <SwipeableDrawer
      tabIndex={0}
      anchor='bottom'
      open={isOpen}
      onClose={toggleDrawer}
      onOpen={toggleDrawer}
      sx={drawerStyles}
    >
      <ThemeProvider theme={composeTheme('light')}>
        <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <Grid sx={{ width: '36px' }} />
          <Grid sx={{ padding: 2, maxWidth: '80vw' }}>{header}</Grid>
          <IconButton onClick={toggleDrawer}>
            <Times />
          </IconButton>
        </Grid>
        <Grid sx={{ padding: 1, overflowY: 'scroll' }}>{children}</Grid>

        {footer && <Grid sx={{ padding: 2 }}>{footer}</Grid>}
      </ThemeProvider>
    </SwipeableDrawer>
  ) : null;
};
